import axiosClient from '../../configs/axios';


class DriverMasterService {
    // Get list 
    async getDriverList(params) {
        try {
            const response = await axiosClient.get(
                `/driver/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addDriver(data) {
        try {
            const response = await axiosClient.post('/driver/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteDriver(data) {
        try {
            const response = await axiosClient.put(`/driver/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DriverMasterService(); 